import Notifications from 'components/Notifications'
import Providers from 'Providers'
import { useEffect } from 'react'
import { authorization } from 'store/user'
import customImageSrc from './assets/images/snow.png'
import Pages from './pages'
import services from './services'
import store from './store'
const snowflakeImage = document.createElement('img')
snowflakeImage.src = customImageSrc
const App = () => {
	useEffect(() => {
		const getUser = () => {
			const token = localStorage.getItem('token') || ''
			const loading = () => {
				store.dispatch(authorization({ STATUS: 'LOADING', user: null }))
			}
			const login = user => {
				store.dispatch(authorization({ STATUS: 'SUCCESS', user }))
			}
			const logout = () => {
				store.dispatch(authorization({ STATUS: 'ERROR', user: null }))
			}
			const serverError = () => {
				const data = { STATUS: 'SERVER_ERROR', user: null }
				store.dispatch(data)
			}
			if (token) {
				const options = {
					onStart: loading,
					onError: error => {
						if (
							typeof error?.toJSON === 'function' &&
							error?.toJSON()?.status === 500
						) {
							serverError()
						} else {
							logout()
						}
					},
					onSuccess: response => {
						const user = response?.data
						const status = response?.status
						if (status === 200 && user) {
							login(user)
						} else {
							logout()
						}
					},
				}
				services.users.getProfile(options)
			} else {
				logout()
			}
		}
		getUser()
	}, [])
	return (
		<Providers>
			<Pages />
			<Notifications />
			{/* <Snowfall
				radius={[5.0, 15.0]}
				style={{
					position: 'fixed',
					zIndex: 99,
					width: '100vw',
					height: '100vh',
					pointerEvents: 'none',
				}}
				images={[snowflakeImage]}
			/> */}
		</Providers>
	)
}

export default App
